<template>
  <PopupTemplate
    v-if="show"
    class="exclude-popup"
    v-on="$listeners"
    @close="onClose"
  >
    <div class="exclude-popup__container">
      <div class="mb-2">
        <BaseLabel for-id="comment">Комментарий</BaseLabel>
        <BaseTextarea
          id="comment"
          label="comment"
          v-model="comment"
          :has-error="hasError"
        />
        <BaseError v-if="hasError">
          {{ error }}
        </BaseError>
      </div>
      <div class="mt-4 flex flex-row justify-end">
        <BaseButton class="mr-4" size="sm" variant="blue" @click="onSave">
          Отправить
        </BaseButton>
      </div>
    </div>
  </PopupTemplate>
</template>

<script>
  import PopupTemplate from './PopupTemplate';
  import BaseLabel from '@/components/global/base-label';
  import BaseError from '@/components/global/base-error';
  import BaseButton from '@/components/global/base-button';
  import BaseTextarea from '@/components/global/base-textarea';

  export default {
    name: 'MeasureConditionPopup',

    components: {
      BaseError,
      BaseLabel,
      BaseButton,
      BaseTextarea,
      PopupTemplate,
    },

    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        error: null,
        comment: null,
      };
    },

    computed: {
      hasComment() {
        if (!this.comment) {
          return false;
        }
        return this.comment.length > 0;
      },

      hasError() {
        if (!this.error) {
          return false;
        }
        return this.error.length > 0;
      }
    },

    methods: {
      onSave() {
        if (!this.hasComment) {
          this.error = 'Обязательно для заполенения';
          return;
        }

        this.$emit('save', this.comment);
        this.onClose();
      },
      onClose() {
        this.error = null;
        this.comment = null;
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .exclude-popup {
    &__container {
      width: rem(500px);
    }
  }
</style>
